import { render, staticRenderFns } from "./successBox.vue?vue&type=template&id=04a36237&scoped=true&"
import script from "./successBox.vue?vue&type=script&lang=js&"
export * from "./successBox.vue?vue&type=script&lang=js&"
import style0 from "./successBox.vue?vue&type=style&index=0&id=04a36237&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a36237",
  null
  
)

export default component.exports